import globalConfig from '@utiles/officialStore/globalConfig';

const gameInfoConfig = {
  175: {
    // 是否展示优惠券弹窗中的跳转vip规则按钮：跳到V1看
    showCouponRule: false,
    // 没有配置权益中心链接时，不展示权益中心。原来是会展示入口，只是没有配置时会弹窗提示尽请期待
    hideRightsWhenNoConfig: false,
    // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID：匹配同档位代金券
    autoChangeProduct: false,
    // 指定地区隐藏加码：当一个游戏只下某个地区的加码时，在选渠道页面加载了渠道列表后才返回这个有没有加码。一开始init_data的price_list都有返回，只能根据init_data的current_location来手动判断
    hideExtraCoinIcon: [],
    // 根据标识替换移动端的banner
    replaceMobileBanner: [
      {
        enname: 'vbrohihj',
        imgMap: {
          'ar-SA': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-ar-SA.jpg'),
          'de-DE': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-de-DE.jpg'),
          'en-US': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-en-US.jpg'),
          'es-ES': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-es-ES.jpg'),
          'fr-FR': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-fr-FR.jpg'),
          'it-IT': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-it-IT.jpg'),
          'ko-KR': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-ko-KR.jpg'),
          'pl-PL': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-pl-PL.jpg'),
          'pt-PT': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-pt-PT.jpg'),
          'ru-RU': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-ru-RU.jpg'),
          'th-TH': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-th-TH.jpg'),
          'tr-TR': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-tr-TR.jpg'),
          'vi-VN': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-vi-VN.jpg'),
          'zh-TW': require('@assets/image/officialTopupNew/tmslg/m-banner-vbrohihj-zh-TW.jpg')
        }
      },
      {
        enname: 'tcawxgez',
        imgMap: {
          'ar-SA': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-ar-SA.jpg'),
          'de-DE': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-de-DE.jpg'),
          'en-US': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-en-US.jpg'),
          'es-ES': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-es-ES.jpg'),
          'fr-FR': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-fr-FR.jpg'),
          'id-ID': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-id-ID.jpg'),
          'it-IT': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-it-IT.jpg'),
          'ja-JP': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-ja-JP.jpg'),
          'ko-KR': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-ko-KR.jpg'),
          'pl-PL': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-pl-PL.jpg'),
          'pt-PT': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-pt-PT.jpg'),
          'ru-RU': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-ru-RU.jpg'),
          'th-TH': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-th-TH.jpg'),
          'tr-TR': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-tr-TR.jpg'),
          'vi-VN': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-vi-VN.jpg'),
          'zh-TW': require('@assets/image/officialTopupNew/tmslg/m-banner-tcawxgez-zh-TW.jpg')
        }
      }
    ],
    // 隐藏商品描述
    hideProductContent: false
  },
  191: {
    // 是否展示优惠券弹窗中的跳转vip规则按钮：跳到V1看
    showCouponRule: true,
    // 没有配置权益中心链接时，不展示权益中心。原来是会展示入口，只是没有配置时会弹窗提示尽请期待
    hideRightsWhenNoConfig: false,
    // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID：匹配同档位代金券
    autoChangeProduct: false,
    // 指定地区隐藏加码：当一个游戏只下某个地区的加码时，在选渠道页面加载了渠道列表后才返回这个有没有加码。一开始init_data的price_list都有返回，只能根据init_data的current_location来手动判断
    hideExtraCoinIcon: [],
    // 根据标识替换移动端的banner
    replaceMobileBanner: [
      {
        enname: 'ugevkzdv',
        imgMap: {
          'ar-SA': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-en-US.jpg'),
          'de-DE': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-de-DE.jpg'),
          'en-US': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-en-US.jpg'),
          'es-ES': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-en-US.jpg'),
          'fr-FR': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-fr-FR.jpg'),
          'id-ID': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-en-US.jpg'),
          'it-IT': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-en-US.jpg'),
          'ja-JP': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-ja-JP.png'),
          'ko-KR': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-ko-KR.jpg'),
          'pl-PL': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-en-US.jpg'),
          'pt-PT': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-en-US.jpg'),
          'ru-RU': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-ru-RU.jpg'),
          'th-TH': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-en-US.jpg'),
          'tr-TR': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-en-US.jpg'),
          'vi-VN': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-en-US.jpg'),
          'zh-TW': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-zh-TW.jpg'),
          'zh-CN': require('@assets/image/officialTopupNew/pns/m-banner-ugevkzdv-en-US.jpg'),
        }
      },
      {
        enname: 'csrrksao',
        imgMap: {
          'ar-SA': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-en-US.jpg'),
          'de-DE': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-de-DE.jpg'),
          'en-US': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-en-US.jpg'),
          'es-ES': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-es-ES.jpg'),
          'fr-FR': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-fr-FR.jpg'),
          'id-ID': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-id-ID.jpg'),
          'it-IT': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-it-IT.jpg'),
          'ja-JP': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-ja-JP.jpg'),
          'ko-KR': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-ko-KR.jpg'),
          'pl-PL': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-pl-PL.jpg'),
          'pt-PT': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-pt-PT.jpg'),
          'ru-RU': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-ru-RU.jpg'),
          'th-TH': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-th-TH.jpg'),
          'tr-TR': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-tr-TR.jpg'),
          'vi-VN': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-vi-VN.jpg'),
          'zh-CN': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-zh-CN.jpg'),
          'zh-TW': require('@assets/image/officialTopupNew/pns/m-banner-csrrksao-zh-TW.jpg')
        }
      }
    ],
    // 隐藏商品描述
    hideProductContent: false
  },
  285: {
    // 是否展示优惠券弹窗中的跳转vip规则按钮：跳到V1看
    showCouponRule: true,
    // 没有配置权益中心链接时，不展示权益中心。原来是会展示入口，只是没有配置时会弹窗提示尽请期待
    hideRightsWhenNoConfig: false,
    // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID：匹配同档位代金券
    autoChangeProduct: false,
    // 指定地区隐藏加码：当一个游戏只下某个地区的加码时，在选渠道页面加载了渠道列表后才返回这个有没有加码。一开始init_data的price_list都有返回，只能根据init_data的current_location来手动判断
    hideExtraCoinIcon: [],
    // 根据标识替换移动端的banner
    replaceMobileBanner: [
      {
        enname: 'cookagaw',
        imgMap: {
          'ar-SA': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-ar-SA.jpg'),
          'de-DE': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-de-DE.jpg'),
          'en-US': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-en-US.jpg'),
          'es-ES': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-es-ES.jpg'),
          'fr-FR': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-fr-FR.jpg'),
          'id-ID': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-id-ID.jpg'),
          'it-IT': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-it-IT.jpg'),
          'ko-KR': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-ko-KR.jpg'),
          'pl-PL': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-pl-PL.jpg'),
          'pt-PT': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-pt-PT.jpg'),
          'ru-RU': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-ru-RU.jpg'),
          'th-TH': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-th-TH.jpg'),
          'tr-TR': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-tr-TR.jpg'),
          'vi-VN': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-vi-VN.jpg'),
          'zh-TW': require('@assets/image/officialTopupNew/dtmslg/m-banner-cookagaw-zh-TW.jpg')
        }
      },
      {
        enname: 'xzdvxwdm',
        imgMap: {
          'ar-SA': require('@assets/image/officialTopupNew/dtmslg/m-banner-xzdvxwdm-ar-SA.jpg'),
          'de-DE': require('@assets/image/officialTopupNew/dtmslg/m-banner-xzdvxwdm-de-DE.jpg'),
          'en-US': require('@assets/image/officialTopupNew/dtmslg/m-banner-xzdvxwdm-en-US.jpg'),
          'es-ES': require('@assets/image/officialTopupNew/dtmslg/m-banner-xzdvxwdm-es-ES.jpg'),
          'fr-FR': require('@assets/image/officialTopupNew/dtmslg/m-banner-xzdvxwdm-fr-FR.jpg'),
          'id-ID': require('@assets/image/officialTopupNew/dtmslg/m-banner-xzdvxwdm-id-ID.jpg'),
          'pt-PT': require('@assets/image/officialTopupNew/dtmslg/m-banner-xzdvxwdm-pt-PT.jpg'),
          'ru-RU': require('@assets/image/officialTopupNew/dtmslg/m-banner-xzdvxwdm-ru-RU.jpg'),
          'th-TH': require('@assets/image/officialTopupNew/dtmslg/m-banner-xzdvxwdm-th-TH.jpg'),
          'tr-TR': require('@assets/image/officialTopupNew/dtmslg/m-banner-xzdvxwdm-tr-TR.jpg'),
          'vi-VN': require('@assets/image/officialTopupNew/dtmslg/m-banner-xzdvxwdm-vi-VN.jpg'),
          'zh-TW': require('@assets/image/officialTopupNew/dtmslg/m-banner-xzdvxwdm-zh-TW.jpg')
        }
      }
    ],
    // VIP积分下架说明
    vipScoreDownIntro: {
      isShow: (() => {
        const curDate = new Date();

        return (
          curDate > new Date('2025-10-17T00:00:00+08:00') &&
          curDate < new Date('2025-11-17T23:59:59+08:00')
        );
      })(),
      langMap: {
        'en-US': {
          show: true,
          headerTip: 'Coupon Changes Comparison',
          footerTip:
            'Note: Coupon discount caps in the Privilege Center are based on USD and may fluctuate with exchange rates. The actual discount amount will be displayed on the usage page.',
          tableHeaderTip: [
            'Premium Membership Level',
            'Original VIP Level',
            'Coupon Discount',
            'Acquisition Limit',
            'Max Discount Cap'
          ],
          tableBodyTip: [
            ['Bronze', 'VIP1', '5%', 'Once Daily', 'US$15'],
            ['Silver', 'VIP2', '7%', '15 per Month', ''],
            ['Gold', 'VIP3', '9%', '15 per Month', ''],
            ['Platinum', 'VIP4', '11%', '10 per Month', ''],
            ['Diamond', 'VIP5', '13%', '10 per Month', '']
          ],
          popupTitle: 'VIP Points System Upgraded to Privilege Center',
          popupContent:
            "Greetings, Lord!\nThank you for supporting the game! In order to provide you with a better gaming experience, the VIP Points system will be replaced with the new Privilege Center on 11/1/2025. The old VIP privileges will be integrated into the new system, and has new added benefits as well. Details are as follows:\nI. Changes Details\nBetween 10/17/2025 - 11/17/2025, all players logged in to the official purchases website will still receive the Weekly VIP Coupon, and the number the number of coupons obtained is based on the VIP Points Event.\nStarting from 11/18/2025, all players can redeem new coupons in the Privilege Center. The Privilege Center's coupons have a maximum deduction limit. Refer to the table at the bottom of the page for new coupon rules and available quantities.\nNote: Automatic coupon distribution needs to be manually activated. How to Activate: Privilege Center Homepage - View Member Privileges - Automatic Coupon Distribution - Tap/Click Activate - Select the Coupon to be Automatically Redeemed - Confirm Activation\nII. New Points Redemptions\nThe Privilege Center has a Points Redemption feature. Players can earn points by logging in to the game and completing the quests shown in the Privilege Center to redeem exclusive coupons, rare items, and other valuable rewards (see the Privilege Center interface for specific quantities available).\nCarried Over VIP Levels\nYour VIP level and accumulated points will be carried over to the Privilege Center, automatically converting to the corresponding Privilege Center Lv., with original VIP privileges retained and upgraded."
        },
        'zh-CN': {
          show: true,
          headerTip: '三方优惠券变动对比',
          footerTip:
            '请注意：【权益中心】优惠券减免上限以USD为基准，受汇率波动影响，以实际使用页面展示为准',
          tableHeaderTip: [
            '兑换门槛-权益中心等级',
            '原VIP等级',
            '优惠券折扣',
            '获取限制',
            '减免上限'
          ],
          tableBodyTip: [
            ['青铜', 'VIP1', '5%', '1次/日', '15USD'],
            ['白银', 'VIP2', '7%', '15次/月', ''],
            ['黄金', 'VIP3', '9%', '15次/月', ''],
            ['铂金', 'VIP4', '11%', '10次/月', ''],
            ['钻石', 'VIP5', '13%', '10次/月', '']
          ],
          popupTitle: '关于VIP积分机制升级为【权益中心】',
          popupContent:
            '尊敬的领主：\n感谢您一直以来的支持！为提供更优质的福利体验，我们将于2025年11月1日对原有VIP积分机制进行全面改版升级，推出全新「权益中心」系统。此次改版将整合原有VIP权益，并新增更多福利，具体调整如下：\n一、改版内容说明\n2025年10月17日-11月17日期间，所有玩家登录【官网储值页】仍可领取「每周VIP优惠券」，可获得优惠券数量与【VIP积分活动】一致。\n2025年11月18日起，所有玩家可以在【权益中心】兑换新版优惠券，权限中心优惠券将会有最高抵扣金额限制，新优惠券规则及可获取数量可参考页面下方表格\n请注意：自动发放优惠券功能需手动开启，开启路径：权益中心首页-查看会员权益-优惠券自动发放-点击开启-选择需要自动兑换的优惠券-确认开启\n二、新增积分兑换福利\n权益中心将开放「积分兑换」功能，玩家可通过参与登录游戏、完成权益中心指定任务等方式获取积分，兑换专属优惠券、稀有道具等超值奖励（具体可兑换数量详见权益中心界面）。\nVIP等级继承保障\n原VIP等级及累计积分将完整继承至权益中心，并自动转换为对应权益中心的等级身份，原有VIP特权将同步保留且优化升级。'
        },
        'zh-TW': {
          show: true,
          headerTip: '優惠券變動對比',
          footerTip:
            '請注意：【權益中心】優惠券折抵上限以美元為基準，受匯率波動影響，以實際使用頁面顯示為準',
          tableHeaderTip: [
            '兌換門檻-大會員等級',
            '原VIP等級',
            '優惠券折扣',
            '獲取限制',
            '折抵上限'
          ],
          tableBodyTip: [
            ['青銅', 'VIP1', '5%', '1次/日', '15美元'],
            ['白銀', 'VIP2', '7%', '15次/月', ''],
            ['黃金', 'VIP3', '9%', '15次/月', ''],
            ['白金', 'VIP4', '11%', '10次/月', ''],
            ['鑽石', 'VIP5', '13%', '10次/月', '']
          ],
          popupTitle: '關於VIP積分機制升級為【權益中心】',
          popupContent:
            '尊敬的領主：\n感謝您一直以來的支持！為提供更優質的福利體驗，我們將於2025年11月1日對原有VIP積分機制進行全面改版升級，推出全新「權益中心」系統。此次改版將整合原有VIP權益，並新增更多福利，具體調整如下：\n一、改版內容說明\n2025年10月17日-11月17日期間，所有玩家登入【官網儲值頁】仍可領取「每週VIP優惠券」，可獲得優惠券數量與【VIP積分活動】一致。\n2025年11月18日起，所有玩家可以在【權益中心】兌換新版優惠券，權限中心優惠券將會有最高抵扣金額限制，新優惠券規則及可獲取數量可參考頁面下方表格。\n請注意：自動發放優惠券功能需手動開啟，開啟路徑：權益中心首頁-查看會員權益-優惠券自動發放-點擊開啟-選擇需要自動兌換的優惠券-確認開啟。\n二、新增積分兌換福利\n權益中心將開放「積分兌換」功能，玩家可透過參與登入遊戲、完成權益中心指定任務等方式獲取積分，兌換專屬優惠券、稀有道具等超值獎勵（具體可兌換數量詳見權益中心介面）。\nVIP等級繼承保障\n原VIP等級及累計積分將完整繼承至權益中心，並自動轉換為對應權益中心的等級身份，原有VIP特權將同步保留且優化升級。'
        },
        'ja-JP': {
          // 日语不展示
          show: false,
          headerTip: '',
          footerTip: '',
          tableHeaderTip: [],
          tableBodyTip: [[], [], [], [], [], []],
          popupTitle:
            'VIPポイントシステムが「プレミアムセンター」へアップグレードしました',
          popupContent:
            'ロードさま、\n日頃よりご愛顧いただき、誠にありがとうございます。より充実した特典体験をご提供するため、2025年11月1日に現行のVIPポイントシステムを全面的にリニューアルし、新たに「プレミアムセンター」システムを導入いたします。今回のリニューアルでは、既存のVIP特典を統合し、さらに多くの特典を追加いたします。具体的な変更点は以下の通りです。\n2025年10月17日から11月17日までの期間、すべてのプレイヤーは「公式チャージページ」にて「週間VIP割引クーポン」を受け取ることができます。\n2025年11月18日より、公式VIP割引クーポンは終了いたします。以降、プレイヤーの皆様は「プレミアムセンター」でゲームアイテムギフトの交換や幸運抽選を参加することとなります。\nプレミアムセンターでは「ポイント交換」機能が開放されます。プレイヤーの皆様はゲームへのログインやプレミアムセンター指定のクエスト完了などでポイントを獲得し、レアアイテムなどの超お得な報酬と交換できます（具体的な交換可能数はプレミアムセンター画面をご確認ください）。'
        },
        'ko-KR': {
          show: true,
          headerTip: '서드 파티 쿠폰 변경 비교',
          footerTip:
            '주의: [혜택 센터] 쿠폰의 할인 한도는 USD 기준이며, 환율 변동의 영향을 받습니다. 실제 사용 페이지에 표시된 내용을 기준으로 합니다.',
          tableHeaderTip: [
            '교환 조건 - 프리미엄 레벨',
            '원래 VIP 레벨',
            '쿠폰 할인',
            '획득 제한',
            '할인 한도'
          ],
          tableBodyTip: [
            ['브론즈', 'VIP1', '5%', 'Once Daily', '15USD'],
            ['실버', 'VIP2', '7%', '15 per Month', ''],
            ['골드', 'VIP3', '9%', '15 per Month', ''],
            ['플래티넘', 'VIP4', '11%', '10 per Month', ''],
            ['다이아', 'VIP5', '13%', '10 per Month', '']
          ],
          popupTitle: 'VIP 포인트 시스템의 [혜택 센터]로의 업그레이드에 관하여',
          popupContent:
            "존경하는 영주님,\n항상 변함없는 성원에 감사드립니다! 더욱 향상된 혜택 경험을 제공하고자 2025년 11월 1일부로 기존 VIP 포인트 시스템을 전면 개편하여 새로운 「혜택 센터」 시스템을 도입할 예정입니다. 이번 개편을 통해 기존 VIP 혜택을 통합하고 더 많은 혜택을 추가할 예정이며, 구체적인 변경 사항은 다음과 같습니다:\n1. 개편 내용 설명\n2025년 10월 17일~11월 17일 기간 동안 모든 유저가 [공식 웹사이트 충전 페이지]에 접속하면 여전히 「주간 VIP 할인 쿠폰」을 받을 수 있으며, 받을 수 있는 할인 쿠폰의 수량은 [VIP 포인트 이벤트]와 동일합니다.\n2025년 11월 18일부터 모든 유저는 [혜택 센터]에서 새로운 할인 쿠폰을 교환할 수 있습니다. 혜택 센터 쿠폰에는 최대 할인 금액 제한이 적용됩니다. 새로운 쿠폰 규정 및 획득 가능 수량은 페이지 하단의 표를 참조하세요.\n주의: 쿠폰 자동 발급 기능은 수동 활성화가 필요합니다. 활성화 경로: 혜택 센터 메인 페이지 - 회원 혜택 보기 - 쿠폰 자동 발급 - 활성화 클릭 - 자동 교환할 쿠폰 선택 - 활성화 확인\n2. 포인트 교환 혜택 신규 추가\n혜택 센터에 '포인트 교환' 기능이 오픈됩니다. 유저는 게임 로그인, 혜택 센터 지정 임무 완료 등을 통해 포인트를 획득하여 전용 할인 쿠폰, 레어 아이템 등 초특가 보상으로 교환할 수 있습니다(구체적인 교환 가능 수량은 혜택 센터 화면을 참조하세요).\nVIP 레벨 승계 보장\n기존 VIP 레벨 및 누적 포인트가 혜택 센터로 완전히 승계되며, 자동으로 해당 혜택 센터의 등급으로 전환됩니다. 기존 VIP 특권은 그대로 유지되며 개선 및 업그레이드됩니다."
        },
        'vi-VN': {
          show: true,
          headerTip: 'So sánh thay đổi Coupon',
          footerTip:
            'Lưu ý: Giới hạn giảm giá phiếu ưu đãi [Trung tâm quyền lợi] dựa trên USD, chịu ảnh hưởng bởi biến động tỷ giá, vui lòng xem trang sử dụng thực tế để biết chi tiết.',
          tableHeaderTip: [
            'Ngưỡng đổi - Cấp hội viên',
            'Cấp độ VIP gốc',
            'Chiết khấu phiếu ưu đãi',
            'Giới hạn nhận',
            'Giới hạn giảm giá'
          ],
          tableBodyTip: [
            ['Đồng', 'VIP1', '5%', '1 lần/ngày', '15 USD'],
            ['Bạc', 'VIP2', '7%', '15 lần/tháng', ''],
            ['Vàng', 'VIP3', '9%', '15 lần/tháng', ''],
            ['Bạch Kim', 'VIP4', '11%', '10 lần/tháng', ''],
            ['Kim Cương', 'VIP5', '13%', '10 lần/tháng', '']
          ],
          popupTitle:
            'Về việc cơ chế điểm VIP nâng cấp thành [Trung Tâm Quyền Lợi]',
          popupContent:
            'Lãnh chúa thân mến:\nCảm ơn các Lãnh chúa đã luôn ủng hộ! Để mang đến trải nghiệm phúc lợi tốt hơn, chúng tôi sẽ tiến hành nâng cấp và cải tiến toàn diện cơ chế điểm VIP hiện có vào ngày 1 tháng 11 năm 2025, từ đó cho ra mắt hệ thống [Trung Tâm Quyền Lợi] hoàn toàn mới. Bản nâng cấp này sẽ tích hợp các quyền lợi VIP hiện có và bổ sung thêm nhiều phúc lợi mới, các điều chỉnh cụ thể như sau:\nI. Nội dung bản cập nhật\nTrong khoảng thời gian từ ngày 17/10/2025 đến 17/11/2025, tất cả người chơi khi đăng nhập [Trang nạp tiền chính thức] vẫn có thể nhận [Phiếu ưu đãi VIP hàng tuần]. Số lượng phiếu ưu đãi nhận được sẽ tương đương với [Hoạt động điểm VIP].\nKể từ ngày 18/11/2025, tất cả người chơi có thể đổi phiếu ưu đãi phiên bản mới tại [Trung tâm quyền lợi]. Phiếu ưu đãi của Trung tâm quyền lợi sẽ có hạn mức khấu trừ tối đa. Quy tắc dùng phiếu ưu đãi mới và số lượng nhận được có thể tham khảo tại bảng bên dưới trang.\nLưu ý: Tính năng phát phiếu ưu đãi tự động cần bật thủ công. Cách bật: Trang chủ Trung tâm quyền lợi - Xem quyền lợi hội viên - Tự động phát phiếu ưu đãi - Nhấn bật - Chọn phiếu ưu đãi cần tự động đổi - Xác nhận bật.\n2. Thêm mới phúc lợi đổi điểm\nTrung tâm quyền lợi sẽ mở tính năng "Đổi điểm". Người chơi có thể nhận điểm bằng cách đăng nhập vào game, hoàn thành nhiệm vụ chỉ định tại Trung tâm quyền lợi và nhiều cách khác, sau đó dùng điểm để đổi các phần thưởng siêu giá trị như phiếu ưu đãi độc quyền, đạo cụ hiếm v.v (Chi tiết số lượng đổi vui lòng xem tại giao diện Trung tâm quyền lợi).\nBảo đảm kế thừa cấp VIP\nCấp VIP cũ và điểm tích lũy sẽ được kế thừa toàn bộ sang Trung tâm quyền lợi và tự động quy đổi thành cấp bậc mới tương ứng. Các đặc quyền VIP hiện có cũng sẽ được giữ lại và tối ưu.'
        },
        'th-TH': {
          show: true,
          headerTip: 'การเปรียบเทียบการเปลี่ยนแปลงคูปอง',
          footerTip:
            'หมายเหตุ: วงเงินส่วนลดสูงสุดของตั๋วโปรโมชั่น [ศูนย์สิทธิประโยชน์] ใช้ USD เป็นเกณฑ์ ซึ่งอาจมีการเปลี่ยนแปลงตามอัตราแลกเปลี่ยน โดยอ้างอิงจากข้อมูลที่แสดงบนหน้าใช้งานจริง',
          tableHeaderTip: [
            'เกณฑ์การแลกเปลี่ยน - ระดับศูนย์สมาชิก',
            'ระดับ VIP เดิม',
            'ส่วนลดตั๋วโปรโมชั่น',
            'ขีดจำกัดการรับ',
            'ขีดจำกัดการลด'
          ],
          tableBodyTip: [
            ['บรอนซ์', 'VIP1', '5%', '1 ครั้ง/วัน', '15 USD'],
            ['ซิลเวอร์', 'VIP2', '7%', '15 ครั้ง/เดือน', ''],
            ['โกลด์', 'VIP3', '9%', '15 ครั้ง/เดือน', ''],
            ['แพลทตินั่ม', 'VIP4', '11%', '10 ครั้ง/เดือน', ''],
            ['ไดมอนด์', 'VIP5', '13%', '10 ครั้ง/เดือน', '']
          ],
          popupTitle: 'แจ้งการอัปเกรดระบบคะแนน VIP เป็น [ศูนย์สิทธิประโยชน์]',
          popupContent:
            'ท่านลอร์ดที่รัก:\nขอบคุณสำหรับการสนับสนุนอย่างต่อเนื่องเสมอมา! เพื่อมอบประสบการณ์สิทธิประโยชน์ที่ดียิ่งขึ้น เราจะทำการปรับปรุงระบบคะแนน VIP เดิมครั้งใหญ่ในวันที่ 2025/11/1 และเปิดตัวระบบใหม่ล่าสุด 「ศูนย์สิทธิประโยชน์」 การปรับปรุงครั้งนี้จะรวบรวมสิทธิประโยชน์ VIP เดิม พร้อมเพิ่มสิทธิประโยชน์ใหม่ๆ อีกมากมาย โดยมีรายละเอียดการปรับเปลี่ยนดังนี้:\n1. รายละเอียดการปรับปรุง\nในช่วงวันที่ 2025/10/17 - 2025/11/17 ผู้เล่นทุกท่านยังสามารถล็อกอิน [หน้าเติมเงินเว็บไซต์ทางการ] เพื่อรับ 「คูปอง VIP รายสัปดาห์」 ได้เช่นเดิม โดยจำนวนคูปองที่ได้รับจะเท่ากับใน [กิจกรรมคะแนน VIP]\nตั้งแต่วันที่ 2025/11/18 ผู้เล่นสามารถแลกคูปองรูปแบบใหม่ได้ที่ [ศูนย์สิทธิประโยชน์] โดยคูปองจะมีการจำกัดยอดส่วนลดสูงสุด สามารถตรวจสอบกฎและจำนวนที่รับได้จากตารางด้านล่าง\nโปรดทราบ: ฟังก์ชันส่งคูปองอัตโนมัติต้องเปิดใช้งานด้วยตนเอง เส้นทาง: หน้าหลักศูนย์สิทธิประโยชน์→ดูสิทธิประโยชน์สมาชิก→ส่งคูปองอัตโนมัติ→คลิกเปิด→เลือกคูปองที่ต้องการแลกอัตโนมัติ→ยืนยัน\n2. เพิ่มสิทธิประโยชน์การแลกคะแนนสะสม\nศูนย์สิทธิประโยชน์จะเปิดให้บริการฟังก์ชัน[แลกคะแนนสะสม] ผู้เล่นสามารถสะสมคะแนนได้จากการล็อกอินเข้าเกม, ทำภารกิจที่ศูนย์สิทธิประโยชน์กำหนด และกิจกรรมอื่นๆ เพื่อแลกรับรางวัลสุดคุ้มมากมาย อาทิ คูปองพิเศษและไอเทมหายาก (ตรวจสอบจำนวนรางวัลที่แลกได้จากหน้าศูนย์สิทธิประโยชน์)\nรับประกันการสืบทอดระดับ VIP\nระดับ VIP และคะแนนสะสมเดิมจะถูกโอนไปยังศูนย์สิทธิประโยชน์ พร้อมแปลงเป็นระดับที่สอดคล้องกันโดยอัตโนมัติ โดยสิทธิพิเศษ VIP เดิมจะยังคงอยู่และได้รับการปรับปรุงให้ดียิ่งขึ้น'
        },
        'de-DE': {
          show: true,
          headerTip: 'Coupon-Änderungsvergleich',
          footerTip:
            'Hinweis: Die Rabattgrenzen für Coupons im Privilegzentrum basieren auf USD und können aufgrund von Wechselkursschwankungen variieren. Der tatsächliche Rabattbetrag wird auf der Nutzungsseite angezeigt.',
          tableHeaderTip: [
            'Einlöseanforderungen - Premium-Mitgliedschaftslevel',
            'Ursprüngliches VIP-Level',
            'Coupon-Rabatt',
            'Erwerbslimit',
            'Max. Rabattgrenze'
          ],
          tableBodyTip: [
            ['Bronze', 'VIP1', '5%', 'Einmal täglich', '15$'],
            ['Silber', 'VIP2', '7%', '15-mal pro Monat', ''],
            ['Gold', 'VIP3', '9%', '15-mal pro Monat', ''],
            ['Platin', 'VIP4', '11%', '10-mal/Monat', ''],
            ['Diamant', 'VIP5', '13%', '10-mal/Monat', '']
          ],
          popupTitle: 'VIP-Punktesystem aufgewertet zum Privilegzentrum',
          popupContent:
            'Hallo Lord!\nVielen Dank für deine Unterstützung des Spiels! Um dir ein besseres Spielerlebnis zu bieten, wird das VIP-Punktesystem am 01.11.2025 durch das neue Privilegzentrum ersetzt. Die alten VIP-Privilegien werden in das neue System integriert und es gibt auch neue zusätzliche Vorteile. Die Details sind wie folgt:\nI. Änderungen im Detail\nZwischen dem 17.10.2025 und dem 17.11.2025 erhalten alle Spieler, die sich auf der offiziellen Kauf-Website anmelden, weiterhin den wöchentlichen VIP-Gutschein, und die Anzahl der erhaltenen Gutscheine basiert auf dem VIP-Punkte-Event.\nAb dem 18.11.2025 können alle Spieler neue Gutscheine im Privilegzentrum einlösen. Die Gutscheine im Privilegzentrum haben eine maximale Ermäßigungsgrenze. Die neuen Gutscheinregeln und verfügbaren Mengen findest du in der Tabelle am Ende der Seite.\nHinweis: Die automatische Gutscheinverteilung muss manuell aktiviert werden. Aktivierungsanleitung: Startseite des Privilegzentrums - Mitgliederprivilegien anzeigen - Automatische Gutscheinverteilung - Tippe auf Aktivieren - Wähle den automatisch einzulösenden Gutschein aus - Bestätige die Aktivierung.\nII. Neue Punkteeinlösungen\nDas Privilegzentrum verfügt über eine Punkteeinlösungsfunktion. Spieler können Punkte sammeln, indem sie sich im Spiel anmelden und die im Privilegzentrum angezeigten Quests erfüllen, um exklusive Gutscheine, seltene Items und andere wertvolle Belohnungen einzulösen (spezifische verfügbare Mengen findest du in der Benutzeroberfläche des Privilegzentrums).\nÜbertragene VIP-Level\nDein VIP-Level und deine gesammelten Punkte werden ins Privilegzentrum übertragen und automatisch in das entsprechende Privilegzentrum Lv. umgewandelt, wobei die ursprünglichen VIP-Privilegien beibehalten und aufgewertet werden.'
        },
        'fr-FR': {
          show: true,
          headerTip: 'Comparaison des modifications de coupons',
          footerTip: `Remarque : les réductions maximales des coupons dans le Centre de privilèges sont basées sur le $ et peuvent varier en fonction des taux de change. Le montant réel de la réduction sera affiché sur la page d'utilisation.`,
          tableHeaderTip: [
            `Conditions d'Échange - Niveau d'Abonnement Premium`,
            `Niveau VIP d'origine`,
            'Réduction de Coupon',
            `Limite d'Acquisition`,
            `Réduction Maximale`
          ],
          tableBodyTip: [
            ['Bronze', 'VIP1', '5%', 'Une Fois par Jour', '15 $'],
            ['Argent', 'VIP2', '7%', '15 fois par mois', ''],
            ['Or', 'VIP3', '9%', '15 fois par mois', ''],
            ['Platine', 'VIP4', '11%', '10 fois par mois', ''],
            ['Diamant', 'VIP5', '13%', '10 fois par mois', '']
          ],
          popupTitle: 'Le système de Points VIP passe au Centre de Privilèges',
          popupContent:
            "Salutations, Seigneur !\nNous vous remercions de votre soutien ! Pour optimiser votre expérience de jeu, le système de Points VIP sera remplacé par le nouveau Centre de Privilèges le 1/11/2025. Vos anciens Privilèges VIP seront intégrés et de nouveaux avantages seront ajoutés. Détails ci-dessous :\nI. Détails des modifications\nDu 17/10/2025 au 17/11/2025, tout joueur se connectant à la boutique officielle continuera de recevoir le Coupon VIP hebdomadaire. Le nombre de coupons obtenus dépendra de l'événement Points VIP.\nDès le 18/11/2025, tous les joueurs pourront réclamer de nouveaux coupons au Centre de Privilèges. Les coupons du Centre de Privilèges sont soumis à un plafond de déduction. Consultez le tableau en bas de page pour connaître les nouvelles règles et les quantités disponibles.\nRemarque : La distribution automatique de coupons doit être activée manuellement. Comment activer : Page d'accueil du Centre de Privilèges - Voir les Privilèges de membre - Distribution automatique de Coupons - Appuyez/Cliquez sur Activer - Sélectionnez le Coupon à réclamer automatiquement - Confirmez l'activation.\nII. Nouveaux échanges de points\nLe Centre de Privilèges propose une fonctionnalité d'Échange de points. Les joueurs peuvent gagner des points en se connectant au jeu et en accomplissant les quêtes affichées dans le Centre de Privilèges pour réclamer des coupons exclusifs, des objets rares et d'autres récompenses précieuses (consultez l'interface du Centre de Privilèges pour les quantités exactes disponibles).\nNiveaux VIP reportés\nVotre niveau VIP et vos points cumulés seront transférés au Centre de Privilèges, se convertissant automatiquement en un niveau de Centre de Privilèges correspondant. Vos Privilèges VIP d'origine seront maintenus et améliorés."
        },
        'ru-RU': {
          show: true,
          headerTip: 'Сравнение изменений купонов',
          footerTip:
            'Обратите внимание: купонная скидка в Центре привилегий рассчитывается в долларах США и может меняться в зависимости от курса валют. Фактический размер скидки будет отображаться на странице использования.',
          tableHeaderTip: [
            'Требования к обмену – уровень Премиум участника',
            'Исходный VIP-уровень',
            'Купонная скидка',
            'Лимит получения',
            'Максимальная скидка'
          ],
          tableBodyTip: [
            ['Бронза', 'VIP1', '5%', 'Раз в день', '$15'],
            ['Серебро', 'VIP2', '7%', '15 раз/мес.', ''],
            ['Золото', 'VIP3', '9%', '15 раз/мес.', ''],
            ['Платина', 'VIP4', '11%', '10 раз/мес.', ''],
            ['Алмаз', 'VIP5', '13%', '10 раз/мес.', '']
          ],
          popupTitle: 'Система VIP-очков улучшена до Центра привилегий',
          popupContent:
            'Приветствуем, Лорд!\nБлагодарим за поддержку игры! Для улучшения игрового процесса система VIP-очков будет заменена новым Центром привилегий 1/11/2025. Старые VIP-привилегии будут интегрированы в новую систему и дополнены новыми бонусами. Подробности ниже:\nI. Подробности изменений\nС 17/10/2025 по 17/11/2025 все игроки, посетившие официальный сайт пополнения счета, по-прежнему будут получать еженедельные VIP-купоны, при этом количество получаемых купонов будет определяться событием VIP-очков.\nС 18/11/2025 все игроки смогут обменять новые купоны в Центре привилегий. Купоны Центра привилегий обладают максимальным лимитом скидок. Новые правила купонов и их количество смотрите в таблице внизу страницы.\nПримечание: автоматическую выдачу купонов нужно активировать вручную. Как активировать: Центр привилегий - Обзор привилегий - Автоматическая выдача купонов - Нажать "Активировать" - Выбрать купон для автообмена - Подтвердить активацию\nII. Обмен новых очков\nВ Центре привилегий доступна функция обмена очков. Игроки могут зарабатывать очки за вход в игру и выполнение заданий Центра привилегий, чтобы обменять их на эксклюзивные купоны, редкие предметы и другие ценные награды (количество доступных наград смотрите в интерфейсе Центра привилегий).\nПеренос VIP-уровней\nВаш VIP-уровень и накопленные очки будут перенесены в Центр привилегий и автоматически конвертированы в соответствующий уровень Центра привилегий. При этом исходные VIP-привилегии сохранятся и будут улучшены.'
        },
        'pt-PT': {
          show: true,
          headerTip: 'Comparação de alterações de cupom',
          footerTip:
            'Nota: Os limites de desconto de cupom no Centro de Privilégios são baseados em USD (Dólares) e podem variar com as taxas de câmbio. O valor real do desconto será exibido na página de uso.',
          tableHeaderTip: [
            'Requisitos de Resgate - Nível de Associação Premium',
            'Nível VIP original',
            'Desconto do cupom',
            'Limite de Aquisição',
            'Limite Máximo de Desconto'
          ],
          tableBodyTip: [
            ['Bronze', 'VIP1', '5%', 'Uma vez por dia', '$15'],
            ['Prata', 'VIP2', '7%', '15 Vezes/Mês', ''],
            ['Ouro', 'VIP3', '9%', '15 Vezes/Mês', ''],
            ['Platina', 'VIP4', '11%', '10 Vezes/Mês', ''],
            ['Diamante', 'VIP5', '13%', '10 Vezes/Mês', '']
          ],
          popupTitle:
            'Sistema de Pontos VIP atualizado para Centro de Privilégios',
          popupContent:
            'Saudações, Lorde!\nObrigado por apoiar o jogo! Para lhe proporcionar uma melhor experiência de jogo, o sistema de Pontos VIP será substituído pelo novo Centro de Privilégios em 01/11/2025. Os antigos privilégios VIP serão integrados ao novo sistema e, também, possui novos benefícios adicionados. Os detalhes são os seguintes:\nI. Detalhes das Mudanças\nEntre 17/10/2025 e 17/11/2025, todos os jogadores que entrarem no site oficial de compras ainda receberão o Cupom VIP Semanal, e o número de cupons obtidos tem base no Evento de Pontos VIP.\nA partir de 18/11/2025, todos os jogadores podem resgatar novos cupons no Centro de Privilégios. Os cupons do Centro de Privilégios têm um limite máximo de dedução. Consulte a tabela na parte inferior da página para conhecer as novas regras de cupons e as quantidades disponíveis.\nObservação: a distribuição automática de cupons precisa ser ativada manualmente. Como Ativar: Página Inicial do Centro de Privilégios - Ver Privilégios de Membros - Distribuição Automática de Cupons - Toque/Clique em Ativar - Selecione o Cupom a ser Resgatado Automaticamente - Confirme a Ativação\nII. Novos Resgates de Pontos\nO Centro de Privilégios possui um recurso de Resgate de Pontos. Os jogadores podem ganhar pontos entrando no jogo e concluindo as missões mostradas no Centro de Privilégios para resgatar cupons exclusivos, itens raros e outras recompensas valiosas (consulte a interface do Centro de Privilégios para quantidades específicas disponíveis).\nNíveis VIP Transferidos\nO seu nível VIP e os pontos acumulados serão transferidos para o Centro de Privilégios, convertendo automaticamente para o nv. correspondente do Centro de Privilégios, com os privilégios VIP originais mantidos e atualizados.'
        },
        'es-ES': {
          show: true,
          headerTip: 'Comparación de cambios en cupones',
          footerTip:
            'Nota: Los límites de descuento de los cupones del Centro de privilegios son en USD y pueden fluctuar con los tipos de cambio. El importe real del descuento se mostrará en la página de uso.',
          tableHeaderTip: [
            'Requisitos de canje - Nivel de membresía prémium',
            'Nivel VIP original',
            'Descuento del cupón',
            'Límite de adquisición',
            'Límite máximo de descuento'
          ],
          tableBodyTip: [
            ['Bronce', 'VIP1', '5%', 'Una vez al día', '15 $'],
            ['Plata', 'VIP2', '7%', '15 veces/mes', ''],
            ['Oro', 'VIP3', '9%', '15 veces/mes', ''],
            ['Platino', 'VIP4', '11%', '10 veces/mes', ''],
            ['Diamante', 'VIP5', '13%', '10 veces/mes', '']
          ],
          popupTitle:
            'Sistema de Puntos VIP reemplazado por el Centro de Privilegios',
          popupContent:
            '¡Saludos, milord!\n¡Gracias por seguir apoyando el juego! Con el fin de ofrecerte una mejor experiencia, el sistema de Puntos VIP será reemplazado por el nuevo Centro de Privilegios el 1/11/2025. Los antiguos beneficios VIP se integrarán en este nuevo sistema, que además incluirá ventajas adicionales. Más detalles a continuación:\nI. Detalles de los cambios\nDel 17/10/2025 al 17/11/2025, todos los jugadores que inicien sesión en el sitio oficial de compras seguirán recibiendo el Cupón VIP Semanal. La cantidad de cupones obtenidos se determinará según los resultados del evento de Puntos VIP.\nA partir del 18/11/2025, todos los jugadores podrán canjear nuevos cupones en el Centro de Privilegios. Los cupones del Centro de Privilegios cuentan con un límite máximo de descuento. Consulta la tabla al final de la página para conocer las nuevas reglas de los cupones y las cantidades disponibles.\nNota: La distribución automática de cupones debe activarse manualmente. Cómo activarla:\nCentro de Privilegios - Ver privilegios de miembro - Distribución automática de cupones - Tocar/Hacer clic en Activar - Seleccionar el cupón a canjear automáticamente - Confirmar activación.\nII. Nuevo sistema de canje de puntos\nEl Centro de Privilegios incorpora una función de Canje de Puntos. Los jugadores pueden obtener puntos iniciando sesión en el juego y completando las misiones que aparecen en el Centro de Privilegios. Estos puntos se pueden canjear por cupones exclusivos, objetos raros y otras recompensas valiosas. (Consulta la interfaz del Centro de Privilegios para ver las cantidades disponibles).\nTransferencia de Niveles VIP\nTu nivel VIP y los puntos acumulados se transferirán automáticamente al Centro de Privilegios, convirtiéndose en el nivel equivalente dentro del nuevo sistema. Tus privilegios VIP originales se conservarán y recibirán mejoras adicionales en el Centro de Privilegios.'
        },
        'it-IT': {
          show: true,
          headerTip: 'Confronto delle modifiche ai coupon',
          footerTip: `Nota: I massimali di sconto dei buoni nel Centro Privilegi si basano su USD e possono variare in base ai tassi di cambio. L'importo effettivo dello sconto viene visualizzato nella pagina di utilizzo.`,
          tableHeaderTip: [
            'Requisiti per il Riscatto - Membro Livello Premium',
            'Livello VIP originale',
            'Sconto Buono',
            'Limite di Acquisizione',
            'Limite Sconto Massimo'
          ],
          tableBodyTip: [
            ['Bronzo', 'VIP1', '5%', 'Una Volta al Giorno', '$15'],
            ['Argento', 'VIP2', '7%', '15 Volte/Mese', ''],
            ['Oro', 'VIP3', '9%', '15 Volte/Mese', ''],
            ['Platino', 'VIP4', '11%', '10 Volte/Mese', ''],
            ['Diamante', 'VIP5', '13%', '10 Volte/Mese', '']
          ],
          popupTitle:
            'Aggiornamento del Sistema Punti VIP: Ecco il Centro Privilegi',
          popupContent:
            "Saluti, Signore!\nGrazie per il tuo sostegno! Per garantirti un'esperienza di gioco ancora migliore, a partire dall'11/1/2025 il sistema Punti VIP verrà sostituito dal nuovo Centro Privilegi. I privilegi VIP precedenti saranno integrati nel nuovo sistema, con l'aggiunta di nuovi vantaggi. Di seguito i dettagli:\nI. Dettagli delle Modifiche\nDal 17/10/2025 al 17/11/2025, tutti i giocatori che accederanno al sito ufficiale degli acquisti continueranno a ricevere il Buono VIP settimanale; il numero di buoni ottenuti dipenderà dall'Evento Punti VIP.\nA partire dal 18/11/2025, tutti i giocatori potranno riscattare nuovi buoni nel Centro Privilegi. I buoni prevedono un limite di sconto massimo. Per il nuovo regolamento e le quantità disponibili, consulta la tabella a fondo pagina.\nNota: la distribuzione automatica dei buoni va attivata manualmente. Come attivare: Homepage Centro Privilegi - Visualizza Privilegi Membro - Distribuzione Automatica Buoni - Tocca Attiva - Seleziona buono da riscattare in automatico - Conferma Attivazione\nII. Nuovi Riscatti Punti\nIl Centro Privilegi dispone della funzione Riscatto Punti. I giocatori guadagnano punti accedendo al gioco e completando le missioni indicate nel Centro Privilegi, per poi riscattare buoni esclusivi, oggetti rari e altre preziose ricompense (le quantità disponibili sono visibili nell'interfaccia del Centro Privilegi).\nMantenimento Livelli VIP\nIl tuo livello VIP e i punti accumulati verranno trasferiti al Centro Privilegi e convertiti automaticamente nel Liv. corrispondente. I privilegi VIP originali saranno mantenuti e potenziati."
        },
        'id-ID': {
          show: true,
          headerTip: 'Perbandingan Perubahan Kupon',
          footerTip:
            'Perhatian: Limit maksimal diskon kupon di [Pusat Benefit] berdasarkan USD. Karena fluktuasi nilai tukar, jumlah yang ditampilkan di halaman penggunaan aktual adalah yang berlaku.',
          tableHeaderTip: [
            'Syarat Penukaran - Level Anggota VIP',
            'Level VIP Asli',
            'Diskon Kupon',
            'Limit perolehan',
            'Limit diskon'
          ],
          tableBodyTip: [
            ['Bronze', 'VIP1', '5%', '1x/hari', '15USD'],
            ['Silver', 'VIP2', '7%', '15x/bulan', ''],
            ['Gold', 'VIP3', '9%', '15x/bulan', ''],
            ['Platinum', 'VIP4', '11%', '10x/bulan', ''],
            ['Diamond', 'VIP5', '13%', '10x/bulan', '']
          ],
          popupTitle:
            'Tentang perubahan mekanisme Poin VIP menjadi [Pusat Benefit]',
          popupContent:
            'Lord Terhormat:\nTerima kasih atas dukunganmu selama ini! Untuk memberikan pengalaman benefit yang lebih baik, kami akan melakukan pembaruan menyeluruh pada mekanisme Poin VIP yang ada pada 1/11/2025, dan meluncurkan sistem baru "Pusat Benefit". Pembaruan ini akan mengintegrasikan benefit VIP yang ada dan menambahkan lebih banyak keuntungan. Berikut rincian perubahannya:\nI. Penjelasan Isi Pembaruan\nSelama periode 17/10/2025-17/11/2025, semua pemain yang login ke [halaman top up resmi] masih bisa mengambil "Kupon Diskon VIP Mingguan", jumlah kupon yang didapat sama dengan [Event Poin VIP].\nMulai 18/11/2025, semua pemain dapat menukarkan kupon baru di [Pusat Benefit]. Kupon di Pusat Benefit akan memiliki batas maksimum potongan harga. Aturan kupon baru dan jumlah yang bisa didapatkan dapat dilihat di tabel di bawah halaman.\nPerhatian: Fitur pemberian kupon otomatis perlu diaktifkan secara manual. Cara mengaktifkan: Halaman utama Pusat Benefit - Cek benefit member - Pemberian kupon otomatis - Klik aktifkan - Pilih kupon yang ingin ditukar otomatis - Konfirmasi aktivasi\nII. Penambahan Benefit Penukaran Poin\nPenukaran Poin aoam dibuka di Pusat Benefit. Pemain bisa mendapatkan poin dengan login game, menyelesaikan misi tertentu di Pusat Benefit, dll. Poin bisa ditukar dengan kupon eksklusif, Item langka, dan Hadiah bernilai tinggi lainnya (jumlah yang bisa ditukar bisa dilihat di antarmuka Pusat Benefit).\nJaminan pewarisan level VIP\nLevel VIP asli dan total poin akan diwariskan sepenuhnya ke Pusat Benefit, dan secara otomatis dikonversi menjadi Level yang sesuai di Pusat Benefit. Hak istimewa VIP yang ada akan dipertahankan dan ditingkatkan.'
        },
        'tr-TR': {
          show: true,
          headerTip: 'Kupon Değişiklikleri Karşılaştırması',
          footerTip:
            'Not: Ayrıcalık Merkezi’ndeki kupon indirim limitleri ABD doları bazındadır ve döviz kurlarına bağlı olarak değişebilir. Gerçek indirim tutarı kullanım sayfasında görüntülenecektir.',
          tableHeaderTip: [
            'Kullanım Koşulları - Ayrıcalıklı Üyelik Seviyesi',
            'Orijinal VIP Seviyesi',
            'Kupon İndirimi',
            'Satın Alma Limiti',
            'Maksimum İndirim Sınırı'
          ],
          tableBodyTip: [
            ['Bronz', 'VIP1', '5%', 'Günde bir kez', '$15'],
            ['Gümüş', 'VIP2', '7%', '15 Kez/Ayda', ''],
            ['Altın', 'VIP3', '9%', '15 Kez/Ayda', ''],
            ['Platin', 'VIP4', '11%', '10 Kez/Ayda', ''],
            ['Elmas', 'VIP5', '13%', '10 Kez/Ayda', '']
          ],
          popupTitle: 'VIP Puanı Sistemi, Ayrıcalık Merkezi Olarak Güncellendi',
          popupContent:
            "Selamlar, Lordum!\nOyunumuza gösterdiğin destek için müteşekkiriz! Size daha iyi bir oyun deneyimi sunabilmek için, 1 Kasım 2025 tarihi itibarıyla VIP Puan sistemi yerini yeni Ayrıcalık Merkezi'ne bırakacak. Eski VIP ayrıcalıkları yeni sisteme entegre edilecek ve yeni faydalar da eklenecek. Ayrıntılar şöyle:\nI. Değişiklik Detayları\n17 Ekim 2025 - 17 Kasım 2025 tarihleri arasında, resmi satın alma sitesine giriş yapan tüm oyuncular Haftalık VIP Kuponlarını alacak ve kupon sayısı VIP Puanı Etkinliği'ne göre belirlenecek.\n18 Kasım 2025 tarihinden itibaren tüm oyuncular Ayrıcalık Merkezi'nde yeni kuponları kullanabilecek. Ayrıcalık Merkezi'ndeki kuponlar için maksimum indirim limiti bulunuyor. Yeni kupon kuralları ve mevcut miktarlar için sayfanın altındaki tabloya göz atın.\nNot: Otomatik kupon dağıtımının manuel olarak etkinleştirilmesi gerekir. Nasıl Etkinleştirilir: Ayrıcalık Merkezi Ana Sayfası - Üye Ayrıcalıklarını Görüntüle - Otomatik Kupon Dağıtımı - Etkinleştir'e Dokun/Tıkla - Otomatik Kullanılacak Kuponu Seç - Etkinleştirmeyi Onayla\nII. Yeni Puan Kullanımları\nAyrıcalık Merkezi'nde Puan Kullanma özelliği bulunmaktadır. Oyuncular, oyuna giriş yaparak ve Ayrıcalık Merkezi'nde gösterilen görevleri tamamlayarak puan kazanabilir ve bu puanları kullanarak özel kuponlar, nadir öğeler ve diğer değerli ödüller alabilirler (mevcut miktarlar için Ayrıcalık Merkezi arayüzüne göz atın).\nAktarılan VIP Seviyeleri\nVIP seviyeniz ve birikmiş puanlarınız Ayrıcalık Merkezi'ne aktarılarak otomatik olarak karşılık gelen Ayrıcalık Merkezi Seviyesine dönüştürülecek, orijinal VIP ayrıcalıkları korunacak ve yükseltilecek."
        }
      }
    },
    // 隐藏商品描述
    hideProductContent: false
  },
  405: {
    // 是否展示优惠券弹窗中的跳转vip规则按钮：跳到V1看
    showCouponRule: false,
    // 没有配置权益中心链接时，不展示权益中心。原来是会展示入口，只是没有配置时会弹窗提示尽请期待
    hideRightsWhenNoConfig: true,
    // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID
    autoChangeProduct: true,
    // 指定地区隐藏加码：当一个游戏只下某个地区的加码时，在选渠道页面加载了渠道列表后才返回这个有没有加码。一开始init_data的price_list都有返回，只能根据init_data的current_location来手动判断
    hideExtraCoinIcon: [],
    // 根据标识替换移动端的banner
    replaceMobileBanner: [],
    // 隐藏商品描述
    hideProductContent: false
  },
  429: {
    // 是否展示优惠券弹窗中的跳转vip规则按钮：跳到V1看
    showCouponRule: false,
    // 没有配置权益中心链接时，不展示权益中心。原来是会展示入口，只是没有配置时会弹窗提示尽请期待
    hideRightsWhenNoConfig: false,
    // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID：匹配同档位代金券
    autoChangeProduct: true,
    // 指定地区隐藏加码：当一个游戏只下某个地区的加码时，在选渠道页面加载了渠道列表后才返回这个有没有加码。一开始init_data的price_list都有返回，只能根据init_data的current_location来手动判断
    hideExtraCoinIcon: [],
    // 根据标识替换移动端的banner
    replaceMobileBanner: [
      {
        enname: 'fmugwkfb',
        imgMap: {
          'de-DE': require('@assets/image/officialTopupNew/looteu/m-banner-fmugwkfb-de-DE.png'),
          'en-US': require('@assets/image/officialTopupNew/looteu/m-banner-fmugwkfb-en-US.png'),
          'fr-FR': require('@assets/image/officialTopupNew/looteu/m-banner-fmugwkfb-fr-FR.png'),
          'ru-RU': require('@assets/image/officialTopupNew/looteu/m-banner-fmugwkfb-ru-RU.png')
        }
      }
    ],
    // 隐藏商品描述
    hideProductContent: false
  },
  263: {
    // 是否展示优惠券弹窗中的跳转vip规则按钮：跳到V1看
    showCouponRule: false,
    // 没有配置权益中心链接时，不展示权益中心。原来是会展示入口，只是没有配置时会弹窗提示尽请期待
    hideRightsWhenNoConfig: false,
    // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID：匹配同档位代金券
    autoChangeProduct: false,
    // 指定地区隐藏加码：当一个游戏只下某个地区的加码时，在选渠道页面加载了渠道列表后才返回这个有没有加码。一开始init_data的price_list都有返回，只能根据init_data的current_location来手动判断
    hideExtraCoinIcon: ['JP'],
    // 根据标识替换移动端的banner
    replaceMobileBanner: [
      {
        enname: 'ltwjyxtc',
        imgMap: {
          'de-DE': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-de-DE.jpg'),
          'en-US': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-en-US.jpg'),
          'fr-FR': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-fr-FR.jpg'),
          'ru-RU': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-ru-RU.jpg'),
          'zh-TW': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-zh-TW.jpg'),
          'tr-TR': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-tr-TR.jpg'),
          'th-TH': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-th-TH.jpg'),
          'vi-VN': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-vi-VN.jpg'),
          'pt-PT': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-pt-PT.jpg'),
          'it-IT': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-it-IT.jpg'),
          'pl-PL': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-pl-PL.jpg'),
          'id-ID': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-id-ID.jpg'),
          'ar-SA': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-ar-SA.jpg'),
          'es-ES': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-es-ES.jpg'),
          'ja-JP': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-ja-JP.jpg'),
          'ko-KR': require('@assets/image/officialTopupNew/antslg/m-banner-ltwjyxtc-ko-KR.jpg')
        }
      },
      {
        enname: 'rvzldswd',
        imgMap: {
          'de-DE': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-de-DE.jpg'),
          'en-US': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-en-US.jpg'),
          'fr-FR': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-fr-FR.jpg'),
          'ru-RU': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-ru-RU.jpg'),
          'zh-TW': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-zh-TW.jpg'),
          'tr-TR': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-tr-TR.jpg'),
          'th-TH': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-th-TH.jpg'),
          'ar-SA': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-ar-SA.jpg'),
          'pl-PL': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-pl-PL.jpg'),
          'pt-PT': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-pt-PT.jpg'),
          'vi-VN': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-vi-VN.jpg'),
          'ja-JP': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-ja-JP.jpg'),
          'ko-KR': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-ko-KR.jpg'),
          'it-IT': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-it-IT.jpg'),
          'id-ID': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-id-ID.jpg'),
          'es-ES': require('@assets/image/officialTopupNew/antslg/m-banner-rvzldswd-es-ES.jpg')
        }
      }
    ],
    // 隐藏商品描述
    hideProductContent: false
  },
  430: {
    // 是否展示优惠券弹窗中的跳转vip规则按钮：跳到V1看
    showCouponRule: false,
    // 没有配置权益中心链接时，不展示权益中心。原来是会展示入口，只是没有配置时会弹窗提示尽请期待
    hideRightsWhenNoConfig: false,
    // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID：匹配同档位代金券
    autoChangeProduct: true,
    // 指定地区隐藏加码：当一个游戏只下某个地区的加码时，在选渠道页面加载了渠道列表后才返回这个有没有加码。一开始init_data的price_list都有返回，只能根据init_data的current_location来手动判断
    hideExtraCoinIcon: [],
    // 根据标识替换移动端的banner
    replaceMobileBanner: [
      {
        enname: 'zlslctgf',
        imgMap: {
          'ko-KR': require('@assets/image/officialTopupNew/lootkr/m-banner-zlslctgf-ko-KR.png')
        }
      }
    ],
    // 隐藏商品描述
    hideProductContent: false
  },
  412: {
    // 是否展示优惠券弹窗中的跳转vip规则按钮：跳到V1看
    showCouponRule: false,
    // 没有配置权益中心链接时，不展示权益中心。原来是会展示入口，只是没有配置时会弹窗提示尽请期待
    hideRightsWhenNoConfig: false,
    // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID：匹配同档位代金券
    autoChangeProduct: false,
    // 指定地区隐藏加码：当一个游戏只下某个地区的加码时，在选渠道页面加载了渠道列表后才返回这个有没有加码。一开始init_data的price_list都有返回，只能根据init_data的current_location来手动判断
    hideExtraCoinIcon: [],
    // 根据标识替换移动端的banner
    replaceMobileBanner: [
      {
        enname: 'kkmucesc',
        imgMap: {
          'de-DE': require('@assets/image/officialTopupNew/sgdbzkr/m-banner-kkmucesc-ko-KR.png')
        }
      },
      {
        enname: 'ovpsmbeg',
        imgMap: {
          'de-DE': require('@assets/image/officialTopupNew/sgdbzkr/m-banner-ovpsmbeg-ko-KR.png')
        }
      }
    ],
    // 隐藏商品描述
    hideProductContent: false
  },
  411: {
    // 是否展示优惠券弹窗中的跳转vip规则按钮：跳到V1看
    showCouponRule: false,
    // 没有配置权益中心链接时，不展示权益中心。原来是会展示入口，只是没有配置时会弹窗提示尽请期待
    hideRightsWhenNoConfig: false,
    // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID：匹配同档位代金券
    autoChangeProduct: false,
    // 指定地区隐藏加码：当一个游戏只下某个地区的加码时，在选渠道页面加载了渠道列表后才返回这个有没有加码。一开始init_data的price_list都有返回，只能根据init_data的current_location来手动判断
    hideExtraCoinIcon: [],
    // 根据标识替换移动端的banner
    replaceMobileBanner: [
      {
        enname: 'qdqhodgn',
        imgMap: {
          'en-US': require('@assets/image/officialTopupNew/sgdbzsea/m-banner-qdqhodgn-en-US.png'),
          'ru-RU': require('@assets/image/officialTopupNew/sgdbzsea/m-banner-qdqhodgn-ru-RU.png'),
          'th-TH': require('@assets/image/officialTopupNew/sgdbzsea/m-banner-qdqhodgn-th-TH.png')
        }
      },
      {
        enname: 'cjizfoaj',
        imgMap: {
          'en-US': require('@assets/image/officialTopupNew/sgdbzsea/m-banner-cjizfoaj-en-US.png'),
          'ru-RU': require('@assets/image/officialTopupNew/sgdbzsea/m-banner-cjizfoaj-ru-RU.png'),
          'th-TH': require('@assets/image/officialTopupNew/sgdbzsea/m-banner-cjizfoaj-th-TH.png')
        }
      }
    ],
    // 隐藏商品描述
    hideProductContent: false
  },
  410: {
    // 是否展示优惠券弹窗中的跳转vip规则按钮：跳到V1看
    showCouponRule: false,
    // 没有配置权益中心链接时，不展示权益中心。原来是会展示入口，只是没有配置时会弹窗提示尽请期待
    hideRightsWhenNoConfig: false,
    // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID：匹配同档位代金券
    autoChangeProduct: false,
    // 指定地区隐藏加码：当一个游戏只下某个地区的加码时，在选渠道页面加载了渠道列表后才返回这个有没有加码。一开始init_data的price_list都有返回，只能根据init_data的current_location来手动判断
    hideExtraCoinIcon: [],
    // 根据标识替换移动端的banner
    replaceMobileBanner: [
      {
        enname: 'fgahubpa',
        imgMap: {
          'ja-JP': require('@assets/image/officialTopupNew/sgdzzjp/m-banner-fgahubpa-ja-JP.png')
        }
      },
      {
        enname: 'aoacwpci',
        imgMap: {
          'ja-JP': require('@assets/image/officialTopupNew/sgdzzjp/m-banner-aoacwpci-ja-JP.png')
        }
      }
    ],
    // 隐藏商品描述
    hideProductContent: false
  },
  402: {
    // 是否展示优惠券弹窗中的跳转vip规则按钮：跳到V1看
    showCouponRule: false,
    // 没有配置权益中心链接时，不展示权益中心。原来是会展示入口，只是没有配置时会弹窗提示尽请期待
    hideRightsWhenNoConfig: false,
    // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID：匹配同档位代金券
    autoChangeProduct: false,
    // 指定地区隐藏加码：当一个游戏只下某个地区的加码时，在选渠道页面加载了渠道列表后才返回这个有没有加码。一开始init_data的price_list都有返回，只能根据init_data的current_location来手动判断
    hideExtraCoinIcon: [],
    // 根据标识替换移动端的banner
    replaceMobileBanner: [
      {
        enname: 'mhqtbhqs',
        imgMap: {
          'en-US': require('@assets/image/officialTopupNew/sgdbztw/m-banner-mhqtbhqs-en-US.png'),
          'zh-TW': require('@assets/image/officialTopupNew/sgdbztw/m-banner-mhqtbhqs-zh-TW.png')
        }
      }
    ],
    // 隐藏商品描述
    hideProductContent: false
  },
  390: {
    // 是否展示优惠券弹窗中的跳转vip规则按钮：跳到V1看
    showCouponRule: false,
    // 没有配置权益中心链接时，不展示权益中心。原来是会展示入口，只是没有配置时会弹窗提示尽请期待
    hideRightsWhenNoConfig: false,
    // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID：匹配同档位代金券
    autoChangeProduct: false,
    // 指定地区隐藏加码：当一个游戏只下某个地区的加码时，在选渠道页面加载了渠道列表后才返回这个有没有加码。一开始init_data的price_list都有返回，只能根据init_data的current_location来手动判断
    hideExtraCoinIcon: [],
    // 根据标识替换移动端的banner
    replaceMobileBanner: [
      {
        enname: 'kfkmkuef',
        imgMap: {
          'ar-SA': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-ar-SA.png'),
          'de-DE': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-de-DE.png'),
          'en-US': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-en-US.png'),
          'es-ES': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-es-ES.png'),
          'fr-FR': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-fr-FR.png'),
          'id-ID': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-id-ID.png'),
          'it-IT': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-it-IT.png'),
          'ja-JP': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-ja-JP.png'),
          'ko-KR': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-ko-KR.png'),
          'pl-PL': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-pl-PL.png'),
          'pt-PT': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-pt-PT.png'),
          'ru-RU': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-ru-RU.png'),
          'th-TH': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-th-TH.png'),
          'tr-TR': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-tr-TR.png'),
          'vi-VN': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-vi-VN.png'),
          'zh-TW': require('@assets/image/officialTopupNew/muglo/m-banner-kfkmkuef-zh-TW.png')
        }
      }
    ],
    // 隐藏商品描述
    hideProductContent: false
  },
  426: {
    // 是否展示优惠券弹窗中的跳转vip规则按钮：跳到V1看
    showCouponRule: false,
    // 没有配置权益中心链接时，不展示权益中心。原来是会展示入口，只是没有配置时会弹窗提示尽请期待
    hideRightsWhenNoConfig: false,
    // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID
    autoChangeProduct: false,
    // 指定地区隐藏加码：当一个游戏只下某个地区的加码时，在选渠道页面加载了渠道列表后才返回这个有没有加码。一开始init_data的price_list都有返回，只能根据init_data的current_location来手动判断
    hideExtraCoinIcon: [],
    // 根据标识替换移动端的banner
    replaceMobileBanner: [],
    // 隐藏商品描述
    hideProductContent: true
  },
  386: {
    hideDefaultLogin: true // 隐藏默认登录方式（账密登录、OTP登录）
  }
};

export const ZTMSLG_GAMES = [191, 225, 227, 284];
export const DTMSLG_GAMES = [285, 354, 355];

// 使用productID+remark匹配商品的游戏
export const NEED_REMARK_GAMES = [183, 215, 213, 251, 261, 209, 211, 289, 296, 307];

export const DOMAIN_MAP = {
  191: [window.atob('MzdnYW1lcy5jb20='), 'pnsofficial.com', 'blancozone.com'], // 主版本游戏域名：需要包含分版本游戏域名
  225: ['blancozone.com'], // 分版本游戏域名
  227: ['blancozone.com'], // 分版本游戏域名
  284: [window.atob('MzdnYW1lcy5jb20='), 'pnsofficial.com'], // 分版本游戏域名

  285: [window.atob('MzdnYW1lcy5jb20=')], // 主版本游戏域名：需要包含分版本游戏域名
  354: ['blancozone.com'], // 分版本游戏域名
  355: [] // 分版本游戏域名，看到支付页管理后台没有配置，先空着
};

export const mergeGameDomainList = domainList => {
  const set = new Set(domainList);
  const gameId =
    globalConfig.getHrefParam('gameId') ||
    globalConfig.getHrefParam('gameID') ||
    globalConfig.getHrefParam('game_id') ||
    '';
  if (DOMAIN_MAP[Number(gameId)]) {
    DOMAIN_MAP[Number(gameId)].forEach(domain => {
      set.add(domain);
    });
  }
  return Array.from(set);
};

export default gameInfoConfig;
